// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"113":"870d94d9d6a580fd","767":"f212e5a7574f0261"}[chunkId] + ".js";
};